// extracted by mini-css-extract-plugin
export default {"item":"Form_item__mSW0L","footer":"Form_footer__tASa0"};